import { HOME_ROUTE_PATH } from '@flowwai-frontend/bps-officer-web/common/data-access'

const LOGIN_SUCCESS_PATH = 'login_success_path'
const IS_SESSION_LOGOUT_MODAL_OPEN = 'is_session_logout_modal_open'

export function setPath(path = HOME_ROUTE_PATH) {
   window.localStorage.setItem(LOGIN_SUCCESS_PATH, path)
}

export function getPath(): string {
   return window.localStorage.getItem(LOGIN_SUCCESS_PATH) || HOME_ROUTE_PATH
}

export function setIsSessionLogoutModalOpen(isOpen: boolean) {
   window.localStorage.setItem(IS_SESSION_LOGOUT_MODAL_OPEN, isOpen.toString())
}

export function getIsSessionLogoutModalOpen(): string {
   return (
      window.localStorage.getItem(IS_SESSION_LOGOUT_MODAL_OPEN) ||
      false.toString()
   )
}
